import SocialShareLinks from './social-links';

export default {
  init: function (selector) {
    const shareButtons = document.querySelectorAll(selector);

    if (shareButtons && shareButtons.length) {
      [...shareButtons].map(item => {
        const socialShareLinks = new SocialShareLinks(item);
        socialShareLinks.init();
      });
    }
  }
};
